import { useNavigate, useSearch } from '@tanstack/react-router';

import type { AdsTxtAppsFoundCriteria } from './model';
import {
  parseAdsTxtAppsRouteSearch,
  serializeAdsTxtAppsRouteSearch,
} from './adsTxtAppsRouteSearch';

export function useAdsTxtAppsRouteFilters() {
  const navigate = useNavigate({ from: '/supply/ads-txt/apps' });
  const search = useSearch({ from: '/supply/ads-txt/apps' });
  const filter = parseAdsTxtAppsRouteSearch(search);
  const update = (next: typeof filter) =>
    void navigate({ search: serializeAdsTxtAppsRouteSearch(next), replace: true });
  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setPublishers: (publisherIds: string[]) => {
      update({ ...filter, publisherIds, page: 0 });
    },
    setFoundCriteria: (foundCriteria: AdsTxtAppsFoundCriteria) => {
      update({ ...filter, foundCriteria, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
  };
}
